import { render, staticRenderFns } from "./Duels.vue?vue&type=template&id=c070bce4&scoped=true"
import script from "./Duels.vue?vue&type=script&lang=js"
export * from "./Duels.vue?vue&type=script&lang=js"
import style0 from "./Duels.vue?vue&type=style&index=0&id=c070bce4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c070bce4",
  null
  
)

export default component.exports